export default function marklines(userTheme, passedSeriesConfig, categories) {
   return {
      markLine: {
         data: passedSeriesConfig.markLines.map((m) => {
            return m.coords.map((c) => {
               return {
                  name: m.name,
                  coord: c.map((c) => {
                     if (typeof c === "string") {
                        let index = categories.findIndex((item) => item === c);
                        return index;
                     }
                     return c;
                  }),
                  lineStyle: {
                     type: m.lineStyle ? m.lineStyle : "solid",
                     width: 4,
                     shadowColor:
                        userTheme === "Dark"
                           ? "rgba(0, 0, 0, 1)"
                           : "rgba(255, 255, 255, 1)",
                     shadowBlur: 3,
                     color: m.color ? m.color : passedSeriesConfig.color,
                  },
                  symbol: "none",
                  tooltip: {
                     formatter: `${m.name}`,
                  },
                  label: {
                     show: false,
                  },
               };
            });
         }),
      },
   };
}
